<app-enfaf-modal
  svgIcon="mail"
  [title]="'Enviar email a estudiantes del curso: ' + courseName"
  buttonCancelText="Cancelar"
  (onClose)="confirmCloseModal()"
  buttonConfirmText="Enviar"
  (onConfirm)="sendEmail()"
  [isLoading]="isSendingEmail"
  [disableConfirmButton]="emailForm.invalid || isSendingEmail"
>
    <form class="modal-content" [formGroup]="emailForm" autocomplete="off">

      <enfaf-input 
        color="light"
        label="Asunto"
        placeholder="Asunto"
        [control]="emailForm.controls.subject"
        name="subject"
        autocomplete="off"
        type="text"
        errorLabel="Asunto requerido"
      />

      <app-enfaf-textarea-light 
        label="Mensaje"
        placeholder="Mensaje"
        [control]="emailForm.controls.message"
        name="message"
        [rows]="10"
        autocomplete="off"
        errorLabel="Mensaje requerido"
      />

      <app-enfaf-input-file-dragger-light
        [acceptMultiple]="true"
        [acceptLimit]="10"
        [maxFileSize]="25000000"
        [accept]="'*'"
        (filesDropped)="onDroppedFiles($event)">
      </app-enfaf-input-file-dragger-light>

    </form>
</app-enfaf-modal>
